import { render, staticRenderFns } from "./ModalTaskMonitor.vue?vue&type=template&id=0da4971c&scoped=true"
import script from "./ModalTaskMonitor.vue?vue&type=script&lang=js"
export * from "./ModalTaskMonitor.vue?vue&type=script&lang=js"
import style0 from "./ModalTaskMonitor.vue?vue&type=style&index=0&id=0da4971c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da4971c",
  null
  
)

export default component.exports